export function getLowerPanelDisplays(pluginManager) {
    return (pluginManager
        .getDisplayElements()
        // @ts-expect-error
        .filter(f => { var _a; return ((_a = f.subDisplay) === null || _a === void 0 ? void 0 : _a.type) === 'LinearAlignmentsDisplay'; })
        // @ts-expect-error
        .filter(f => { var _a; return (_a = f.subDisplay) === null || _a === void 0 ? void 0 : _a.lowerPanel; }));
}
